// RankingsUpdates.jsx

import React from "react";

const updates = [
  {
    dateTime: "2025-11-20T10:30",
    title: "🌟 Launch of SAKSHAM Bharat Rankings Portal",
    desc: "Our all-in-one national benchmarking platform is live, empowering citizens, MSMEs, Panchayats, and students with real-time insights."
  },
  {
    dateTime: "2025-11-18T14:00",
    title: "🏆 First SAKSHAM Shakti Top 10 Released",
    desc: "Celebrating excellence: the top 10 women achievers are now live on the SAKSHAM Shakti leaderboard."
  },
  {
    dateTime: "2025-11-15T09:45",
    title: "📊 Udyam Pragati MSME Rankings Published",
    desc: "MSME leaders recognized for innovation, productivity, and digital adoption across India’s industrial clusters."
  },
  {
    dateTime: "2025-11-12T16:20",
    title: "💡 AI-Powered YUVASolver Insights Demo",
    desc: "Think5Whys and analytics integration showcased to evaluate students’ structured problem-solving skills."
  },
  {
    dateTime: "2025-11-10T11:00",
    title: "🌱 SAKSHAM Farmer Index Released",
    desc: "Smart farming, sustainability, and agri-literacy metrics now benchmark India’s top-performing farmers."
  },
  {
    dateTime: "2025-11-08T15:30",
    title: "🏛️ GOVThinker Pilot Program Launched",
    desc: "Government departments onboarded to foster innovation, governance excellence, and digital transformation."
  },
  {
    dateTime: "2025-11-05T13:15",
    title: "👨‍👩‍👧 Healthy Family & Citizen Scorecards Live",
    desc: "Tracking preventive health, wellness, and lifestyle awareness at individual and household levels."
  },
  {
    dateTime: "2025-11-02T17:45",
    title: "📝 Panchayat Digital Readiness Report Published",
    desc: "Local governance rankings highlight citizen engagement, digital adoption, and innovation in Gram Panchayats."
  },
  {
    dateTime: "2025-10-30T10:00",
    title: "🍽 SAKSHAM HORECA Ranking Debut",
    desc: "First-ever comprehensive benchmark for hotels, restaurants, and cafeterias integrating governance, digital initiatives, and local cuisine innovation."
  },
  {
    dateTime: "2025-10-28T09:30",
    title: "🌸 Micro-Cluster Gat Index Launched",
    desc: "Community-based SAKSHAM Gat rankings now live to assess local innovation, social initiatives, and sustainable practices."
  }
];


const RankingsUpdates = () => {
  return (
    <section className="py-2 px-6 bg-black min-h-screen">
      <h2 className="text-lg lg:text-xl font-bold text-center mb-4 text-orange-400">Think5Whys SAKSHAM Rankings Updates</h2>
      <div className="space-y-6">
        {updates.map((update, idx) => (
          <div key={idx} className="bg-black border border-purple-400 rounded-lg shadow-md p-5 hover:shadow-lg transition">
            <div className="text-sm text-gray-400 mb-1">
              {new Date(update.dateTime).toLocaleString('en-IN', {
                dateStyle: 'medium',
                timeStyle: 'short'
              })}
            </div>
            <p className="text-sm lg:text-m font-semibold text-yellow-200">{update.title}</p>
            <p className="text-white text-sm lg:text-m mt-1">{update.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RankingsUpdates;
